import edit from "./job-profile/edit";
import questionnaire from "./job-profile/questionnaire";
import fuzzyMatrix from "./job-profile/fuzzy-matrix";

const store = {
	namespaced: true,
	modules: {
		edit,
		questionnaire,
		fuzzyMatrix
	}
};

export default store;
